
import { useTranslation, Trans } from "react-i18next";
import tr from '../../img/TradingTools/image.png'

function TradingTools() {

  const { t } = useTranslation();

  return (
    <div className="relative pt-[80px] xl:pt-[160px] overflow-hidden">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col">
            <div className="flex flex-col md:flex-row-reverse gap-[20px] justify-between">
                <div className="flex flex-col items-start">
                    <p className="zen-dots leading-[1.2] text-[24px] xl:text-[36px] text-[#FFF] xl:max-w-[605px]">
                        <Trans>{t("trading.13")}</Trans>
                    </p>
                    <p className="xl:max-w-[497px] text-[#FFFFFFB2] text-[14px] ibm-plex mt-[20px]">
                        {t("trading.14")}
                    </p>
                    <div className="grid grid-cols-1 xl:grid-cols-2 mt-[20px] xl:mt-[45px] gap-y-[12px] xl:gap-y-[20px]">
                        <div className="flex items-center gap-[10px] md:gap-[20px] xl:gap-[30px]">
                            <div className="w-[4px] h-[4px] bg-[#1E1C21]"></div>
                            <p className="ibm-plex font-[500] leading-[1.2] text-[#1F1F1F] text-[14px] xl:text-[16px]">{t("trading.15")}</p>
                        </div>
                        <div className="flex items-center gap-[10px] md:gap-[20px] xl:gap-[30px]">
                            <div className="w-[4px] h-[4px] bg-[#1E1C21]"></div>
                            <p className="ibm-plex font-[500] leading-[1.2] text-[#1F1F1F] text-[14px] xl:text-[16px]">{t("trading.17")}</p>
                        </div>
                        <div className="flex items-center gap-[10px] md:gap-[20px] xl:gap-[30px]">
                            <div className="w-[4px] h-[4px] bg-[#1E1C21]"></div>
                            <p className="ibm-plex font-[500] leading-[1.2] text-[#1F1F1F] text-[14px] xl:text-[16px]">{t("trading.16")}</p>
                        </div>
                        <div className="flex items-center gap-[10px] md:gap-[20px] xl:gap-[30px]">
                            <div className="w-[4px] h-[4px] bg-[#1E1C21]"></div>
                            <p className="ibm-plex font-[500] leading-[1.2] text-[#1F1F1F] text-[14px] xl:text-[16px]">{t("trading.18")}</p>
                        </div>
                    </div>
                    <p className="xl:max-w-[497px] text-[#FFFFFFB2] text-[14px] ibm-plex mt-[20px] xl:mt-[40px]">
                        {t("trading.19")}
                    </p>
                </div>
                <img src={tr} alt="" className="mt-[20px] md:mt-auto"/>
            </div>
        </div>
    </div>
  );
}

export default TradingTools;
